import PropTypes from 'prop-types';
import { Link as RouterLink } from 'react-router-dom';
// @mui
// import { useTheme } from '@mui/material/styles';
import { Box } from '@mui/material';
// Images
import logoPng1x from '../assets/logo/logo@1x.png';
import logoPng2x from '../assets/logo/logo@2x.png';
import logoPng3x from '../assets/logo/logo@3x.png';
import logoPng4x from '../assets/logo/logo@4x.png';
// ----------------------------------------------------------------------

Logo.propTypes = {
  disabledLink: PropTypes.bool,
  sx: PropTypes.object,
};

export default function Logo({ disabledLink = false, sx }) {
  // const theme = useTheme();
  // const PRIMARY_LIGHT = theme.palette.primary.light;
  // const PRIMARY_MAIN = theme.palette.primary.main;
  // const PRIMARY_DARK = theme.palette.primary.dark;

  const logo = (
    <Box sx={{ width: 32, height: 32, ...sx }}>
      <img
        alt="tracking"
        src={logoPng1x}
        srcSet={`${logoPng1x} 1x, ${logoPng2x} 2x, ${logoPng3x} 3x, ${logoPng4x} 4x`}
      />
    </Box>
  );

  if (disabledLink) {
    return <>{logo}</>;
  }

  return <RouterLink to="/">{logo}</RouterLink>;
}
